module.exports = __webpack_public_path__ + "PS3icon.png?dfc635033d421a274ab0d4943540d92a";


//////////////////
// WEBPACK FOOTER
// ./src/assets/thumbs/PS3icon.png
// module id = 47
// module chunks = 0